// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.WeddingDashboard_weddingDashboard__dzjNm {
  padding: 0 20px;
}
.WeddingDashboard_weddingDashboard__dzjNm .WeddingDashboard_weddingDashboardInner__uzQvA {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 24px;
  padding: 40px 0;
}
@media (max-width: 768px) {
  .WeddingDashboard_weddingDashboard__dzjNm .WeddingDashboard_weddingDashboardInner__uzQvA {
    grid-template-columns: repeat(1, 1fr);
  }
}
.WeddingDashboard_weddingDashboard__dzjNm .WeddingDashboard_yourParty__GKEqh .WeddingDashboard_partyCards__52-sy > div {
  padding: 0 !important;
}
.WeddingDashboard_weddingDashboard__dzjNm .WeddingDashboard_weddingDashboardHeading__Mrdz9 {
  font: var(--h6);
  font-weight: 600;
  color: var(--primary-Text);
}
.WeddingDashboard_weddingDashboard__dzjNm .WeddingDashboard_yourWeddingDayTimeline__C5nSs {
  margin-top: 1em;
}
.WeddingDashboard_weddingDashboard__dzjNm .WeddingDashboard_yourWeddingDayTimeline__C5nSs .WeddingDashboard_calendarHeading__vFLig {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 15px;
}
.WeddingDashboard_weddingDashboard__dzjNm .WeddingDashboard_yourWeddingDayTimeline__C5nSs .WeddingDashboard_calendarHeading__vFLig .WeddingDashboard_calendarHeadingRight__TVfPk img {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  display: block;
  border: 2px solid var(--success);
  object-fit: cover;
}
.WeddingDashboard_weddingDashboard__dzjNm .WeddingDashboard_yourWeddingDayTimeline__C5nSs .WeddingDashboard_calendarWrp__f\\+Q6f {
  margin-top: 20px;
}
.WeddingDashboard_weddingDashboard__dzjNm .WeddingDashboard_weddingCardsWrp__JHi6w {
  padding: 22px 0;
}
.WeddingDashboard_weddingDashboard__dzjNm .WeddingDashboard_weddingCardsWrp__JHi6w .WeddingDashboard_taskList__JQYEC {
  display: flex;
  flex-direction: column;
  gap: 8px;
  list-style: none;
}
.WeddingDashboard_weddingDashboard__dzjNm .WeddingDashboard_weddingCardsWrp__JHi6w .WeddingDashboard_taskList__JQYEC li {
  padding: 7.5px;
  border-radius: 8px;
  border: 1px solid var(--border);
}
.WeddingDashboard_weddingDashboard__dzjNm .WeddingDashboard_weddingCardsWrp__JHi6w .WeddingDashboard_budgetRow__S3QE2 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 15px;
}
.WeddingDashboard_weddingDashboard__dzjNm .WeddingDashboard_weddingCardsWrp__JHi6w .WeddingDashboard_budgetRow__S3QE2 .WeddingDashboard_chartWrp__GLySQ {
  max-width: 275px;
  width: 100%;
  position: relative;
}
@media (max-width: 1200px) {
  .WeddingDashboard_weddingDashboard__dzjNm .WeddingDashboard_weddingCardsWrp__JHi6w .WeddingDashboard_budgetRow__S3QE2 .WeddingDashboard_chartWrp__GLySQ {
    max-width: 200px;
  }
}
@media (max-width: 500px) {
  .WeddingDashboard_weddingDashboard__dzjNm .WeddingDashboard_weddingCardsWrp__JHi6w .WeddingDashboard_budgetRow__S3QE2 {
    flex-direction: column;
  }
}
.WeddingDashboard_weddingDashboard__dzjNm .WeddingDashboard_weddingCardsWrp__JHi6w .WeddingDashboard_categoryBreakdown__dK4s6 {
  flex: 1 1;
}
.WeddingDashboard_weddingDashboard__dzjNm .WeddingDashboard_weddingCardsWrp__JHi6w .WeddingDashboard_categoryBreakdown__dK4s6 .WeddingDashboard_cardTitle__n1pzC {
  font: var(--body-font-two);
  font-weight: 600;
  color: var(--primary-Text);
  margin-bottom: 12px;
}
@media (max-width: 500px) {
  .WeddingDashboard_weddingDashboard__dzjNm .WeddingDashboard_weddingCardsWrp__JHi6w .WeddingDashboard_categoryBreakdown__dK4s6 {
    width: 100%;
    flex: 1 1;
  }
}
.WeddingDashboard_weddingDashboard__dzjNm .WeddingDashboard_weddingCardsWrp__JHi6w .WeddingDashboard_allocatedCol__-YG6O {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin: 12px 0;
}
.WeddingDashboard_weddingDashboard__dzjNm .WeddingDashboard_weddingCardsWrp__JHi6w .WeddingDashboard_allocatedCol__-YG6O .WeddingDashboard_allocatedAmount__8ZOuF {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}
.WeddingDashboard_weddingDashboard__dzjNm .WeddingDashboard_weddingCardsWrp__JHi6w .WeddingDashboard_allocatedCol__-YG6O .WeddingDashboard_allocatedAmount__8ZOuF h5 {
  font: var(--body-font-three);
  font-weight: 400;
  color: var(--primary-Text);
  text-wrap: nowrap;
  width: fit-content;
}
.WeddingDashboard_weddingDashboard__dzjNm .WeddingDashboard_weddingCardsWrp__JHi6w .WeddingDashboard_allocatedCol__-YG6O .WeddingDashboard_allocatedAmount__8ZOuF h6 {
  font: var(--body-font-three);
  color: var(--primary-Text);
  text-wrap: nowrap;
  width: fit-content;
}
.WeddingDashboard_weddingDashboard__dzjNm .WeddingDashboard_weddingCardsWrp__JHi6w .WeddingDashboard_guestsWrp__M5od\\+ {
  margin-bottom: 16px;
}
.WeddingDashboard_weddingDashboard__dzjNm .WeddingDashboard_weddingCardsWrp__JHi6w .WeddingDashboard_guestsWrp__M5od\\+ .WeddingDashboard_guestsCardWrp__wVdi0 {
  padding: 16px;
  border-radius: var(--border-radius);
  background-color: #EDF7EE;
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.WeddingDashboard_weddingDashboard__dzjNm .WeddingDashboard_weddingCardsWrp__JHi6w .WeddingDashboard_guestsWrp__M5od\\+ .WeddingDashboard_guestsCardWrp__wVdi0 h5 {
  font: var(--h6);
  font-weight: 600;
  color: var(--black);
}
.WeddingDashboard_weddingDashboard__dzjNm .WeddingDashboard_weddingCardsWrp__JHi6w .WeddingDashboard_guestsWrp__M5od\\+ .WeddingDashboard_guestsCardWrp__wVdi0 .WeddingDashboard_info__7J3G3 h6 {
  font: var(--body-font-three);
  color: var(--primary-Text);
  margin-bottom: 4px;
}
.WeddingDashboard_weddingDashboard__dzjNm .WeddingDashboard_weddingCardsWrp__JHi6w .WeddingDashboard_guestsWrp__M5od\\+ .WeddingDashboard_guestsCardWrp__wVdi0 .WeddingDashboard_info__7J3G3 span {
  font: var(--body-font-four);
  color: var(--primary-Text);
}

@media (max-width: 991px) {
  .WeddingDashboard_weddingDashboard__dzjNm {
    padding: 0 16px;
  }
  .WeddingDashboard_weddingDashboard__dzjNm .WeddingDashboard_weddingDashboardInner__uzQvA {
    grid-template-columns: repeat(1, 1fr);
    gap: 15px;
    padding: 20px 0;
  }
}
@media (max-width: 425px) {
  .WeddingDashboard_weddingDashboard__dzjNm .WeddingDashboard_weddingCardsWrp__JHi6w .WeddingDashboard_guestsWrp__M5od\\+ .WeddingDashboard_guestsCardWrp__wVdi0 {
    padding: 7px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/UserDashboard/WeddingDashboard/WeddingDashboard.module.scss"],"names":[],"mappings":"AAAA;EACC,eAAA;AACD;AACC;EACC,aAAA;EACA,qCAAA;EACA,SAAA;EACA,eAAA;AACF;AACE;EAND;IAOE,qCAAA;EAED;AACF;AAIG;EACC,qBAAA;AAFJ;AAOC;EACC,eAAA;EACA,gBAAA;EACA,0BAAA;AALF;AAQC;EACO,eAAA;AANR;AAQE;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,SAAA;AANH;AASI;EACC,WAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;EACA,gCAAA;EACA,iBAAA;AAPL;AAYE;EACC,gBAAA;AAVH;AAcC;EACC,eAAA;AAZF;AAcE;EACC,aAAA;EACA,sBAAA;EACA,QAAA;EACA,gBAAA;AAZH;AAcG;EACC,cAAA;EACA,kBAAA;EACA,+BAAA;AAZJ;AAgBE;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,SAAA;AAdH;AAgBG;EACC,gBAAA;EACA,WAAA;EACA,kBAAA;AAdJ;AAgBI;EALD;IAME,gBAAA;EAbH;AACF;AAgBG;EAhBD;IAiBE,sBAAA;EAbF;AACF;AAiBE;EACC,SAAA;AAfH;AAiBG;EAEC,0BAAA;EACA,gBAAA;EACA,0BAAA;EACA,mBAAA;AAhBJ;AAmBG;EAXD;IAYE,WAAA;IACA,SAAA;EAhBF;AACF;AAmBE;EACC,aAAA;EACA,sBAAA;EACA,SAAA;EACA,cAAA;AAjBH;AAmBG;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;EACA,QAAA;AAjBJ;AAmBI;EACC,4BAAA;EACA,gBAAA;EACA,0BAAA;EACA,iBAAA;EACA,kBAAA;AAjBL;AAoBI;EACC,4BAAA;EACA,0BAAA;EACA,iBAAA;EACA,kBAAA;AAlBL;AA0BE;EACC,mBAAA;AAxBH;AA0BG;EACC,aAAA;EACA,mCAAA;EACA,yBAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AAxBJ;AA0BI;EACC,eAAA;EACA,gBAAA;EACA,mBAAA;AAxBL;AA4BK;EACC,4BAAA;EACA,0BAAA;EACA,kBAAA;AA1BN;AA6BK;EACC,2BAAA;EACA,0BAAA;AA3BN;;AAoCA;EACC;IACC,eAAA;EAjCA;EAmCA;IACC,qCAAA;IACA,SAAA;IACA,eAAA;EAjCD;AACF;AAqCA;EAKI;IACC,YAAA;EAvCH;AACF","sourcesContent":[".weddingDashboard {\r\n\tpadding: 0 20px;\r\n\r\n\t.weddingDashboardInner {\r\n\t\tdisplay: grid;\r\n\t\tgrid-template-columns: repeat(2, 1fr);\r\n\t\tgap: 24px;\r\n\t\tpadding: 40px 0;\r\n\r\n\t\t@media (max-width: 768px) {\r\n\t\t\tgrid-template-columns: repeat(1, 1fr);\r\n\t\t}\r\n\t}\r\n\r\n\t.yourParty {\r\n\r\n\t\t.partyCards {\r\n\t\t\t&>div {\r\n\t\t\t\tpadding: 0 !important;\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n\r\n\t.weddingDashboardHeading {\r\n\t\tfont: var(--h6);\r\n\t\tfont-weight: 600;\r\n\t\tcolor: var(--primary-Text);\r\n\t}\r\n\r\n\t.yourWeddingDayTimeline {\r\n        margin-top: 1em;\r\n\r\n\t\t.calendarHeading {\r\n\t\t\tdisplay: flex;\r\n\t\t\tjustify-content: space-between;\r\n\t\t\talign-items: center;\r\n\t\t\tgap: 15px;\r\n\r\n\t\t\t.calendarHeadingRight {\r\n\t\t\t\timg {\r\n\t\t\t\t\twidth: 34px;\r\n\t\t\t\t\theight: 34px;\r\n\t\t\t\t\tborder-radius: 50%;\r\n\t\t\t\t\tdisplay: block;\r\n\t\t\t\t\tborder: 2px solid var(--success);\r\n\t\t\t\t\tobject-fit: cover;\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n\r\n\t\t.calendarWrp {\r\n\t\t\tmargin-top: 20px;\r\n\t\t}\r\n\t}\r\n\r\n\t.weddingCardsWrp {\r\n\t\tpadding: 22px 0;\r\n\r\n\t\t.taskList {\r\n\t\t\tdisplay: flex;\r\n\t\t\tflex-direction: column;\r\n\t\t\tgap: 8px;\r\n\t\t\tlist-style: none;\r\n\r\n\t\t\tli {\r\n\t\t\t\tpadding: 7.5px;\r\n\t\t\t\tborder-radius: 8px;\r\n\t\t\t\tborder: 1px solid var(--border);\r\n\t\t\t}\r\n\t\t}\r\n\r\n\t\t.budgetRow {\r\n\t\t\tdisplay: flex;\r\n\t\t\tjustify-content: space-between;\r\n\t\t\talign-items: center;\r\n\t\t\tgap: 15px;\r\n\r\n\t\t\t.chartWrp {\r\n\t\t\t\tmax-width: 275px;\r\n\t\t\t\twidth: 100%;\r\n\t\t\t\tposition: relative;\r\n\r\n\t\t\t\t@media (max-width: 1200px) {\r\n\t\t\t\t\tmax-width: 200px;\r\n\t\t\t\t}\r\n\t\t\t}\r\n\r\n\t\t\t@media (max-width: 500px) {\r\n\t\t\t\tflex-direction: column;\r\n\t\t\t}\r\n\r\n\t\t}\r\n\r\n\t\t.categoryBreakdown {\r\n\t\t\tflex: 1;\r\n\r\n\t\t\t.cardTitle {\r\n\r\n\t\t\t\tfont: var(--body-font-two);\r\n\t\t\t\tfont-weight: 600;\r\n\t\t\t\tcolor: var(--primary-Text);\r\n\t\t\t\tmargin-bottom: 12px;\r\n\t\t\t}\r\n\r\n\t\t\t@media (max-width: 500px) {\r\n\t\t\t\twidth: 100%;\r\n\t\t\t\tflex: 1;\r\n\t\t\t}\r\n\t\t}\r\n\r\n\t\t.allocatedCol {\r\n\t\t\tdisplay: flex;\r\n\t\t\tflex-direction: column;\r\n\t\t\tgap: 12px;\r\n\t\t\tmargin: 12px 0;\r\n\r\n\t\t\t.allocatedAmount {\r\n\t\t\t\tdisplay: flex;\r\n\t\t\t\tjustify-content: space-between;\r\n\t\t\t\talign-items: center;\r\n\t\t\t\tflex-wrap: wrap;\r\n\t\t\t\tgap: 8px;\r\n\r\n\t\t\t\th5 {\r\n\t\t\t\t\tfont: var(--body-font-three);\r\n\t\t\t\t\tfont-weight: 400;\r\n\t\t\t\t\tcolor: var(--primary-Text);\r\n\t\t\t\t\ttext-wrap: nowrap;\r\n\t\t\t\t\twidth: fit-content;\r\n\t\t\t\t}\r\n\r\n\t\t\t\th6 {\r\n\t\t\t\t\tfont: var(--body-font-three);\r\n\t\t\t\t\tcolor: var(--primary-Text);\r\n\t\t\t\t\ttext-wrap: nowrap;\r\n\t\t\t\t\twidth: fit-content;\r\n\t\t\t\t}\r\n\r\n\t\t\t}\r\n\r\n\r\n\t\t}\r\n\r\n\t\t.guestsWrp {\r\n\t\t\tmargin-bottom: 16px;\r\n\r\n\t\t\t.guestsCardWrp {\r\n\t\t\t\tpadding: 16px;\r\n\t\t\t\tborder-radius: var(--border-radius);\r\n\t\t\t\tbackground-color: #EDF7EE;\r\n\t\t\t\tdisplay: flex;\r\n\t\t\t\tflex-direction: column;\r\n\t\t\t\tgap: 8px;\r\n\r\n\t\t\t\th5 {\r\n\t\t\t\t\tfont: var(--h6);\r\n\t\t\t\t\tfont-weight: 600;\r\n\t\t\t\t\tcolor: var(--black);\r\n\t\t\t\t}\r\n\r\n\t\t\t\t.info {\r\n\t\t\t\t\th6 {\r\n\t\t\t\t\t\tfont: var(--body-font-three);\r\n\t\t\t\t\t\tcolor: var(--primary-Text);\r\n\t\t\t\t\t\tmargin-bottom: 4px;\r\n\t\t\t\t\t}\r\n\r\n\t\t\t\t\tspan {\r\n\t\t\t\t\t\tfont: var(--body-font-four);\r\n\t\t\t\t\t\tcolor: var(--primary-Text);\r\n\r\n\t\t\t\t\t}\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n}\r\n\r\n@media (max-width: 991px) {\r\n\t.weddingDashboard {\r\n\t\tpadding: 0 16px;\r\n\r\n\t\t.weddingDashboardInner {\r\n\t\t\tgrid-template-columns: repeat(1, 1fr);\r\n\t\t\tgap: 15px;\r\n\t\t\tpadding: 20px 0;\r\n\t\t}\r\n\t}\r\n}\r\n\r\n@media (max-width: 425px) {\r\n\t.weddingDashboard {\r\n\t\t.weddingCardsWrp {\r\n\t\t\t.guestsWrp {\r\n\r\n\t\t\t\t.guestsCardWrp {\r\n\t\t\t\t\tpadding: 7px;\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"weddingDashboard": `WeddingDashboard_weddingDashboard__dzjNm`,
	"weddingDashboardInner": `WeddingDashboard_weddingDashboardInner__uzQvA`,
	"yourParty": `WeddingDashboard_yourParty__GKEqh`,
	"partyCards": `WeddingDashboard_partyCards__52-sy`,
	"weddingDashboardHeading": `WeddingDashboard_weddingDashboardHeading__Mrdz9`,
	"yourWeddingDayTimeline": `WeddingDashboard_yourWeddingDayTimeline__C5nSs`,
	"calendarHeading": `WeddingDashboard_calendarHeading__vFLig`,
	"calendarHeadingRight": `WeddingDashboard_calendarHeadingRight__TVfPk`,
	"calendarWrp": `WeddingDashboard_calendarWrp__f+Q6f`,
	"weddingCardsWrp": `WeddingDashboard_weddingCardsWrp__JHi6w`,
	"taskList": `WeddingDashboard_taskList__JQYEC`,
	"budgetRow": `WeddingDashboard_budgetRow__S3QE2`,
	"chartWrp": `WeddingDashboard_chartWrp__GLySQ`,
	"categoryBreakdown": `WeddingDashboard_categoryBreakdown__dK4s6`,
	"cardTitle": `WeddingDashboard_cardTitle__n1pzC`,
	"allocatedCol": `WeddingDashboard_allocatedCol__-YG6O`,
	"allocatedAmount": `WeddingDashboard_allocatedAmount__8ZOuF`,
	"guestsWrp": `WeddingDashboard_guestsWrp__M5od+`,
	"guestsCardWrp": `WeddingDashboard_guestsCardWrp__wVdi0`,
	"info": `WeddingDashboard_info__7J3G3`
};
export default ___CSS_LOADER_EXPORT___;
